import gql from 'graphql-tag';

export default gql`
    fragment ReferencePhoto on Funeral {
        ReferencePhoto {
            ... on File {
                ID
                AbsoluteLink
                Name
            }
            ... on Image {
                ID
                AbsoluteLink
                Name
            }
        }
    }
`;
